import { Injectable } from '@angular/core';
import { HttpRequestModel, HttpService } from '../httpservice/http.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SmtpConfigurationService {
  HttpRequestModel: HttpRequestModel = new HttpRequestModel();

  constructor(private httpService: HttpService) {}

  //Request to get all site configuration
  getSiteConfiguration(showLoader = false, hideLoader = false): Observable<any> {
    this.HttpRequestModel.reset();
    this.HttpRequestModel.url = 'site_configurations';
    this.HttpRequestModel.method = 'GET';
    this.HttpRequestModel.body = '';

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }

  //Request to create site configuration
  createSiteConfiguration(siteConfigurationInfo, showLoader = false, hideLoader = false): Observable<any> {
    this.HttpRequestModel.reset();
    this.HttpRequestModel.url = 'site_configurations/add';
    this.HttpRequestModel.method = 'POST';
    this.HttpRequestModel.body = siteConfigurationInfo;

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }

  //Request to update specific site configuration
  updateSiteConfiguration(siteConfigurationInfo, showLoader = false, hideLoader = false): Observable<any> {
    this.HttpRequestModel.reset();
    this.HttpRequestModel.url = 'site_configurations/update';
    this.HttpRequestModel.method = 'PUT';
    this.HttpRequestModel.body = siteConfigurationInfo;

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }

  //Request to update site configuration
  addUpdateSiteConfiguration(siteConfigurationInfo, showLoader = false, hideLoader = false): Observable<any> {
    this.HttpRequestModel.reset();
    this.HttpRequestModel.url = 'site_configurations/add_update';
    this.HttpRequestModel.method = 'POST';
    this.HttpRequestModel.body = siteConfigurationInfo;

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }

  //Request to get design info
  saveDesignInfo(formData, showLoader = false, hideLoader = false): Observable<any> {
    this.HttpRequestModel.reset();
    this.HttpRequestModel.url = 'site_configurations/update_design';
    this.HttpRequestModel.method = 'POST';
    // this.HttpRequestModel.formType = 'multipart';
    this.HttpRequestModel.body = formData;

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }
}
